<ng-container>
  <app-modal-filler-atom [index]="(modalZIndex | async) ?? 0"></app-modal-filler-atom>
  <div
    class="fixed left-0 right-0 mx-auto shadow"
    [ngClass]="
      (isMobile$ | async)
        ? 'max-w-screen-sm'
        : 'flex justify-center items-center w-full h-full top-0 left-0'
    "
    [style.z-index]="((modalZIndex | async) ?? 0) + 50"
    [style.bottom.px]="keyboardOffset"
    [style.max-height]="
      availableHeight ? availableHeight + 'px' : (isMobile$ | async) ? '85vh' : null
    "
    [class.bottom-0]="keyboardOffset === 0 && (isMobile$ | async)"
  >
    @if (!availableDistributionModes) {
      <div>Loading</div>
    }

    @if (availableDistributionModes) {
      <div
        class="mx-auto w-full max-w-md bg-white p-5 overflow-y-auto"
        [ngClass]="(isMobile$ | async) ? 'rounded-t-3xl' : 'rounded-3xl min-w-448'"
        [class.pb-8]="isNotched"
        [style.z-index]="((modalZIndex | async) ?? 0) + 50"
        [style.max-height]="
          availableHeight ? availableHeight - 20 + 'px' : (isMobile$ | async) ? '85vh' : null
        "
      >
        @if (orderErrorMessages) {
          <div>
            @for (message of orderErrorMessages; track message) {
              <p class="my-5 rounded bg-error-50 px-4 py-3 font-base text-sm text-error-700">
                {{ message }}
              </p>
            }
          </div>
        }
        @if (existingCartMessage()) {
          <div class="mx-auto mb-7 max-w-sm">
            {{ existingCartMessage() }}
          </div>
        }
        <div class="mb-7">
          <!-- Distribution mode picker -->
          <div>
            @if (availableDistributionModes?.length === 1) {
              <div
                class="mb-4 w-full rounded-full bg-neutral-100 py-3.5 px-4 text-center text-base font-bold text-neutral-800"
              >
                {{ availableDistributionModes[0].label | translate }}
              </div>
            }
            @if (
              (availableDistributionModes?.length ?? 0) > 1 &&
              (availableDistributionModes?.length ?? 0) < 3
            ) {
              <div class="mx-auto mb-4 max-w-sm">
                <app-parameters-distribution-mode-block
                  [selectedDistributionMode]="selectedDistributionMode ?? ''"
                  [isCartParameters]="true"
                  [items]="availableDistributionModes"
                  (selectItem)="changeDistributionMode($event)"
                ></app-parameters-distribution-mode-block>
              </div>
            }
            @if ((availableDistributionModes?.length ?? 0) >= 3) {
              <div class="mx-auto mb-4">
                <app-custom-select-atom
                  [items]="availableDistributionModes"
                  [selectedItem]="selectedDistributionMode"
                  (selectItem)="changeDistributionMode($event)"
                ></app-custom-select-atom>
              </div>
            }
          </div>
          <!-- Message -->
          @if (message) {
            <div
              class="my-4 whitespace-pre-line rounded-md bg-neutral-50 p-4 font-base text-sm text-neutral-700"
            >
              {{ message }}
            </div>
          }
          <!-- Delivery address -->
          @if (
            selectedOrderTypeCapabilities &&
            selectedOrderTypeCapabilities.isDeliveryAddressMandatory
          ) {
            <div class="mx-auto max-w-sm">
              <app-parameters-location-block
                (placeChanged)="placeChanged($event)"
                (addressInputStarted)="onAddressInputStarted()"
                [selectedValue]="selectedLocation?.formatted_address ?? ''"
                [selectedCommentValue]="selectedLocation?.instructions"
              ></app-parameters-location-block>
              @if (!isCheckDeliveryAddressInProgress && deliveryAddressError) {
                <div class="mx-auto max-w-sm">
                  <p class="mt-1 font-base text-xs leading-4 text-secondary-700">
                    {{ deliveryAddressError | translate }}
                  </p>
                </div>
              }
              @if (isCheckDeliveryAddressInProgress) {
                <div class="mx-auto flex max-w-sm flex-row justify-center">
                  <img
                    src="assets/images/spinner.svg"
                    alt=""
                    class="p-2"
                  />
                </div>
              }
              @if (deliverableShop) {
                <div class="mt-8">
                  <h2 class="mb-4 text-lg font-bold text-neutral-800">
                    Un autre point de vente livre à cette addresse
                  </h2>
                  <div class="mb-4 flex justify-between">
                    <div class="flex items-center">
                      <div class="text-sm">
                        <p class="font-bold">{{ deliverableShop.name }}</p>
                        @if (deliverableShop.venue?.address?.street_line1) {
                          <p>
                            {{ deliverableShop.venue?.address?.street_line1 }}
                          </p>
                        }
                        <p>
                          @if (deliverableShop.venue?.address?.post_code) {
                            <span>{{ deliverableShop.venue?.address?.post_code }} </span>
                          }
                          @if (deliverableShop.venue?.address?.city) {
                            <span>{{ deliverableShop.venue?.address?.city }}</span>
                          }
                        </p>
                      </div>
                    </div>
                    <app-button-atom
                      size="S"
                      [label]="'Choisir'"
                      [color]="'primary'"
                      [type]="'light'"
                      [thickSize]="'XS'"
                      (click)="goToShop(deliverableShop)"
                    ></app-button-atom>
                  </div>
                </div>
              }
            </div>
          }
        </div>
        <!-- Delivery Instructions -->
        @if (
          selectedDistributionMode === distributionMode.Delivery &&
          !((userIsLoggedIn$ | async) && selectedLocation?.instructions)
        ) {
          <div class="mx-auto mb-7 max-w-sm">
            <app-parameters-delivery-instructions-block
              [instructions]="$any(deliveryComment)"
              (instructionsChanged)="deliveryCommentChanged($any($event))"
            ></app-parameters-delivery-instructions-block>
          </div>
        }
        <!-- Wanted at -->
        @if (selectedOrderTypeCapabilities?.preorderingAllowed) {
          <div class="mx-auto mb-7 max-w-sm">
            <app-parameters-wanted-at-block
              [dateSlots]="wantedAtDateSlots"
              [timeSlots]="wantedAtTimeSlots"
              [wantedAtType]="selectedWantedAtType ?? ''"
              [wantedAtDate]="selectedWantedAtDate ?? undefined"
              [wantedAtTime]="selectedWantedAtTime ?? undefined"
              [displayAsapForLaterPicker]="displayAsapForLaterPicker()"
              [distributionMode]="selectedDistributionMode ?? ''"
              [estimatedDeliveryDuration]="
                (validation$ | async)?.estimated_delivery_duration ?? undefined
              "
              (typeChanged)="onWantedAtTypeChanged($event)"
              (dateChanged)="onWantedAtDateChanged($event)"
              (timeChanged)="onWantedAtTimeChanged($event)"
            >
            </app-parameters-wanted-at-block>
          </div>
        }
        <!-- On site location -->
        @if (
          selectedOrderTypeCapabilities && selectedOrderTypeCapabilities.isOnSiteLocationMandatory
        ) {
          <div class="mb-7">
            <!--            <ng-container *ngIf="onSiteLocationName">-->
            <!--                Emplacement : {{onSiteLocationName}}-->
            <!--            </ng-container>-->
            @if (activeShop$ | async; as shop) {
              <app-on-site-location-select
                [shop]="shop"
                [selectedOnSiteLocationId]="selectedOnSiteLocationId"
                (onSiteLocationChanged)="onOnSiteLocationChanged($event)"
              ></app-on-site-location-select>
              @if (onSiteLocationError) {
                <p class="mt-1 font-base text-xs leading-4 text-secondary-700">
                  {{ onSiteLocationError | translate }}
                </p>
              }
            }
          </div>
        }
        <!-- Submit -->
        <div class="">
          <app-button-atom
            [iconUrl]="isSaving ? 'assets/images/spinner.svg' : ''"
            [disabled]="
              isSaving ||
              !selectedOrderTypeCapabilities ||
              (selectedOrderTypeCapabilities.isDeliveryAddressMandatory && !isDeliveryAddressValid)
            "
            [color]="'primary'"
            [label]="'parameters.validate' | translate"
            [type]="'primary'"
            [size]="'L'"
            (click)="submit()"
          >
          </app-button-atom>
        </div>
      </div>
    }
  </div>
</ng-container>
